import { render, staticRenderFns } from "./PainelTratamentoRiscos.vue?vue&type=template&id=d29c94da"
import script from "./PainelTratamentoRiscos.vue?vue&type=script&lang=js"
export * from "./PainelTratamentoRiscos.vue?vue&type=script&lang=js"
import style0 from "./PainelTratamentoRiscos.vue?vue&type=style&index=0&id=d29c94da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports